import { Quote } from 'components/Quote'
import { ReactNode } from 'react'

export const content_wirtschaft: {
  title: string
  author: string
  autorBio: string
  content: ReactNode
  link: number
}[] = [
  {
    title: 'Soll ich jetzt Bitcoin kaufen?',
    author: 'Bernhard Kislig',
    autorBio: '58066041/bernhard-kislig',
    content: (
      <>
        <p>
          Es gibt Computer-Nerds, die schon vor 2012 zu einem lächerlich tiefen
          Preis Bitcoin gekauft haben und so mit kleinem Einsatz zu einem
          Millionenvermögen gekommen sind. Der Traum vom schnellen Geld ist
          verlockend. In den vergangenen Jahren wollten mehr und mehr
          Anlegerinnen und Anleger an diesem Erfolg teilhaben und trieben den
          Wert im Herbst 2021 auf 60'000 Franken je Bitcoin.
        </p>
        <p>
          Danach ist der Kurs stark gefallen. In solchen Momenten wittern
          gewisse Optimisten ihre Chance und wollen von einer kräftigen
          Kurserholung profitieren. Tatsächlich hat sich der Bitcoin in der
          Vergangenheit nach Kurseinbrüchen immer wieder erholt und seinen Wert
          über einen Zeitraum von zwei Jahren in der Regel mindestens
          verdoppelt. Doch die Vergangenheit ist keine Garantie für die Zukunft.
        </p>
        <Quote>
          Wer mit gutem Gewissen investieren will, wählt andere
          Kryptowährungen.
        </Quote>
        <p>
          Es gibt zwar gute Gründe, davon auszugehen, dass es mit dem Bitcoin
          wieder aufwärtsgeht. Doch einiges spricht auch dagegen, in die
          Leitwährung des Digitalgelds zu investieren. Allen voran der
          Energieverbrauch: Wer mit gutem Gewissen investieren will, wählt
          deshalb andere Kryptowährungen, die einen Bruchteil der Energie
          benötigen.
        </p>
        <p>
          Und wenn der Bitcoin seine Energiebilanz nicht verbessert, wird sich
          das längerfristig auch in Form von Kursverlusten niederschlagen. Denn
          der politische Druck steigt und nachhaltige Anlagen werden zunehmend
          zum Standard.
        </p>
      </>
    ),
    link: 505905534033,
  },
  {
    title: 'Ist Elon Musk verrückt geworden? ',
    author: 'Matthias Schüssler',
    autorBio: '90426470/matthias-schussler',
    content: (
      <>
        <p>
          Da kauft einer den Kurznachrichtendienst Twitter für 44 Milliarden
          Dollar, und führt sich dann so auf, als würde er seinen Neubesitz
          mutwillig zerstören wollen. Man fragt sich da schon: Hat der noch alle
          Tassen im Schrank? Sollte er nicht wenigstens so viele Mitarbeitende
          behalten, dass sich der technische Betrieb sicher aufrechterhalten
          lässt? Und wäre es nicht klug, nicht auch den letzten Werbekunden zu
          verprellen?
        </p>
        <p>
          Doch das juckt Musk offensichtlich nicht. Er geniesst seinen Auftritt
          als Nonkonformist, für den keine Regeln ausser die eigenen gelten. Ob
          das nun kühn, tollkühn oder irrsinnig ist, wird vermutlich selbst ein
          Psychiater nicht per Ferndiagnose entscheiden können.
        </p>
        <Quote>
          Twitter ist Teil des Informationskriegs, in dem mit Propaganda,
          Desinformation und Hetze gekämpft wird.
        </Quote>
        <p>
          Eines ist aber leider klar: Musk ist kein Visionär, sondern
          Rechthaber. Er will seine Vorstellung von freier Rede durchsetzen,
          egal, wie hoch die gesellschaftlichen Kosten auch sind. Dafür lässt er
          Leute wie den Neonazi Andrew Anglin zurück auf die Plattform, der
          Juden und Frauen hasst. Wie sehr die Verrohung auf Twitter unter Musk
          zugenommen hat, zeigen die Analysen von Bürger- und
          Menschenrechtsorganisationen.
        </p>
        <p>
          Leider ist das alles kein Spiel und keine Hollywood-Schmonzette, in
          der der ungehobelte Held am Schluss recht bekommt und in den
          Sonnenuntergang reitet. Twitter ist Teil des Informationskriegs, in
          dem mit Propaganda, Desinformation und Hetze gekämpft wird. Vielleicht
          sieht das Musk noch ein – aber vielleicht braucht es auch das
          Twitter-Verbot, das die EU angedroht hat. Und vermutlich braucht es
          auch uns Nutzerinnen und Nutzer, die nicht länger nur zusehen. Sondern
          Twitter den Rücken kehren.
        </p>
      </>
    ),
    link: 505905534033,
  },
  {
    title: 'Soll ich kündigen?',
    author: 'Tina Huber',
    autorBio: '26030516/tina-huber',
    content: (
      <>
        <p>
          Für Unentschlossene, die nicht wissen, ob sie das Abenteuer Jobwechsel
          wagen sollen – oder die es sich nicht leisten können, weil sie
          finanzielle Verantwortung tragen –, gibt es seit diesem Jahr eine
          komfortable Alternative: kündigen, ohne zu kündigen. «Quiet Quitting»
          nennt sich das, also ungefähr: im Stillen den Dienst quittieren. Nur
          noch das Allernötigste machen, keine Überstunden, keine Mails in der
          Freizeit beantworten, nach Feierabend die Sintflut.
        </p>
        <p>
          Die Job-Minimalisten, die pünktlich um 16.59 Uhr ausstempelten, gab es
          natürlich schon immer. Nun aber greift dieses Phänomen offenbar nicht
          nur um sich, es wird auch engagiert debattiert, etwa in der «New York
          Times» und im «Spiegel». In der Pandemie haben viele, vor allem junge
          Menschen erkannt, dass sie nicht mehr bereit sind, dem Job ihr ganzes
          Dasein unterzuordnen.
        </p>
        <Quote>
          Wenn sich die Unternehmen mehr Mühe geben müssen, damit ihnen die
          Angestellten nicht davonlaufen, profitieren beide Seiten.
        </Quote>
        <p>
          Verweichlichtes, ambitionsloses Getue oder gesunder Selbstschutz? Klar
          Letzteres. Dass man mit einer solchen Arbeitshaltung keine Karriere
          macht, versteht sich von selbst. Aber niemand braucht sich dafür zu
          entschuldigen, ein Leben neben dem Job zu haben. Und hat sich schon
          jemand am Ende seiner Tage darüber beklagt, zu wenig gebügelt zu
          haben? Eben.
        </p>
        <p>
          Kommt hinzu: Wenn sich die Unternehmen mehr Mühe geben müssen, damit
          ihnen die Angestellten nicht davonlaufen, profitieren am Ende beide
          Seiten. Die Firmen lassen sich auf neue Arbeitsmodelle ein. So
          verbreitet sich derzeit etwa die Viertagewoche nicht nur in
          Kreativberufen, sondern auch in Handwerksbetrieben. Wenn sie im
          Gegenzug auf motivierte und weniger belastete Mitarbeitende zählen
          können, ist das auch in ihrem Sinne.
        </p>
        <p>
          Kündigen Sie also, wenn Ihr Job Sie nicht erfüllt. Im Stillen oder
          ganz offiziell. Und jetzt ab in den Feierabend.
        </p>
      </>
    ),
    link: 659056344266,
  },
]
